import axios from '@fs/zion-axios'
import { useQuery } from '@tanstack/react-query'

// Intentional duplicate of philippines/pages/SurnamePage/hooks/useSurnameRecordData.js

/*
Example response: {
  catalogo: {
    column: 6,
    row: 1,
    page: 122,
    url: 'https://dhbit11dql6h6.cloudfront.net/philippines/catalogo/160.jpg',
  },
  treeRecordsTotal: 33638,
  provinces: [
    ...,
    {
      name: 'manila',
      code: 'PH-MNL',
      recordCount: 2738,
      recordRank: 1,
      populationCount: 12255,
      populationRank: 1,
    },
    ...
  ]
}

Province recordRank and populationRank are determined as follows: 1 - top 2, 2 - top 3-5, 3 - other, 4 - no data
 */

async function surnameRecordData(surname) {
  const { data } = await axios.get(`/service/apac/surname/philippines/surname?surname=${encodeURIComponent(surname)}`)
  return data
}

export default function useSurnameRecordData(surname) {
  return useQuery({
    queryKey: ['surnameRecordData', surname],
    queryFn: () => surnameRecordData(surname),
    enabled: !!surname,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  })
}
